function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
export var FileUploader = /*#__PURE__*/function () {
  function FileUploader() {
    _classCallCheck(this, FileUploader);

    this._invalidFileTypeMessage = "Invalid file type";
    this._invalidFileSizeMessage = "Over a max size of";
    this._selectDifferentFileMessage = "Please select a different file.";
  }

  _createClass(FileUploader, [{
    key: "InitializeFileUploader",
    value: function InitializeFileUploader(name, formContainer, fileUploadComponentHtml, root, invalidFileTypeMessage, invalidFileSizeMessage, selectDifferentFileMessage) {
      this._invalidFileTypeMessage = invalidFileTypeMessage;
      this._invalidFileSizeMessage = invalidFileSizeMessage;
      this._selectDifferentFileMessage = selectDifferentFileMessage;
      var $formRow = document.createElement("div");
      var $formControl = document.createElement("div");
      $formControl.innerHTML = fileUploadComponentHtml;
      $formRow.appendChild($formControl);
      formContainer.appendChild($formRow);
      this._dropArea = root.querySelector("#mppw-upload-droparea-".concat(name));
      this._fileInputId = root.querySelector("#mppw-upload-file-".concat(name));
      this._filePreviewGallery = root.querySelector("#mppw-upload-gallery-".concat(name));
      this._invalidFileTypeLabel = root.querySelector("#mppw-invalid-file-type-label-".concat(name));
      this._invalidFileTypeLabel.style.display = "none";
      this.BindEventListener(root);
    }
  }, {
    key: "BindEventListener",
    value: function BindEventListener(root) {
      var _this = this;

      // Prevent default drag behavior
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
        _this._dropArea.addEventListener(eventName, _this.preventDefaults, false);

        document.body.addEventListener(eventName, _this.preventDefaults, false);
      }); // Highlight drop area when item is dragged over it

      ['dragenter', 'dragover'].forEach(function (eventName) {
        _this._dropArea.addEventListener(eventName, function (event) {
          _this._dropArea.classList.add('highlight');
        });
      });
      ['dragleave', 'drop'].forEach(function (eventName) {
        _this._dropArea.addEventListener(eventName, function (event) {
          _this._dropArea.classList.remove('active');
        });
      }); // Handle dropped files

      this._dropArea.addEventListener('drop', function (event) {
        var dt = event.dataTransfer;
        var files = dt.files;
        _this._fileInputId.files = files;

        _this.handleFiles(files, root);
      }); // Handle onchange


      this._fileInputId.addEventListener('change', function (event) {
        _this.handleFiles(_this._fileInputId.files, root);
      });
    }
  }, {
    key: "preventDefaults",
    value: function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: "validateUploadFileExtension",
    value: function validateUploadFileExtension(fileName) {
      return /\.(pdf|png|gif|jpg|jpeg|jfif|pjpeg|pjp|avif)$/i.test(fileName);
    }
  }, {
    key: "handleFiles",
    value: function handleFiles(files, root) {
      var _this2 = this;

      files = _toConsumableArray(files);
      var fileSize = 0,
          maxFileSize = 20480;

      if (files !== null && files !== undefined && files.length > 1) {
        files = files.slice(0, 1);
      }

      this.clearPreviewFiles();
      files.forEach(function (file) {
        if (file.name) {
          if (file.size > 0) {
            fileSize = Math.round(file.size / 1024);
          }

          if (!_this2.validateUploadFileExtension(file.name)) {
            _this2._invalidFileTypeLabel.style.display = "block";
            _this2._invalidFileTypeLabel.innerHTML = _this2._invalidFileTypeMessage + ", " + file.name + ". " + _this2._selectDifferentFileMessage;
          } else if (fileSize > maxFileSize) {
            _this2._invalidFileTypeLabel.style.display = "block";
            _this2._invalidFileTypeLabel.innerHTML = _this2._invalidFileSizeMessage + " 20MB, " + file.name + ". " + _this2._selectDifferentFileMessage;
          } else {
            _this2.previewFile(file, root);
          }
        }
      });
    }
  }, {
    key: "clearPreviewFiles",
    value: function clearPreviewFiles() {
      this._invalidFileTypeLabel.style.display = "none";

      if (this._filePreviewGallery != null) {
        this._filePreviewGallery.innerHTML = '';
      }
    }
  }, {
    key: "previewFile",
    value: function previewFile(file, root) {
      var self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = function () {
        // Determine placeholder image to show
        var img = document.createElement('img');

        if (file.type.startsWith('image/') === true) {
          // Display uploaded image
          img.src = reader.result;
        } else {
          // Display name and placeholder image
          img.src = new Configuration().GetAppRoot() + '/Content/icons/icon-file-earmark.svg';
        } // Build file preview


        var fileElement = document.createElement('div');
        fileElement.classList.add('mppw-gallery-file');
        var fileName = document.createElement('span');
        fileName.innerHTML += file.name;
        var fileCloseIcon = document.createElement('img');
        fileCloseIcon.setAttribute('title', 'Click to remove this file.');
        fileCloseIcon.classList.add('mppw-gallery-file-close-icon');
        fileCloseIcon.src = new Configuration().GetAppRoot() + "/Content/icons/minus-circle.png";
        fileCloseIcon.addEventListener('click', function handleClick() {
          if (self._filePreviewGallery != null) {
            self._filePreviewGallery.innerHTML = '';
          }

          if (self._fileInputId != null) {
            self._fileInputId.value = null;
          }
        });
        fileElement.appendChild(img);
        fileElement.appendChild(fileName);
        fileElement.appendChild(fileCloseIcon);

        self._filePreviewGallery.appendChild(fileElement);
      };
    }
  }], [{
    key: "UploadFile",
    value: function UploadFile(url, name, file, elem, callback) {
      var xhr = new XMLHttpRequest();
      var fd = new FormData();
      xhr.open("POST", url, true);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var data = JSON.parse(xhr.response);
          if (callback) callback(elem, data);
        }
      };

      fd.append(name, file); // Initiate a multipart/form-data upload

      xhr.send(fd);
    }
  }]);

  return FileUploader;
}();